import { TAppState } from '../../types/appState';

export const userSelector = (state: TAppState) => state.user;
